<div class="sc-payment-method-floating">
    <div *ngIf="loading" class="sc-payment-method-floating__loading">
        <sc-icon icon="loading" size="2"></sc-icon>
        Calculando...
    </div>
    <div *ngIf="!loading" class="sc-payment-method-floating__content">
        <div class="sc-payment-method-floating__methods">
            <div *ngFor="let product of productsData" class="sc-payment-method-floating__method">
                <span class="sc-payment-method-floating__fee">
                    {{ paymentMethod$.value.quoteNro }} Cuota<ng-container *ngIf="paymentMethod$.value.quoteNro > 1">s</ng-container> de
                </span>
                <div class="sc-payment-method-floating__cost" [class.disabled]="disabled">{{ (product.finalAmount / paymentMethod$.value.quoteNro) | scCurrency }}</div>
                <span class="sc-payment-method-floating__final-cost" [class.hidden]="paymentMethod$.value.quoteNro == 1">
                    Precio final: {{ product.finalAmount | scCurrency }}
                </span>
                <div class="sc-payment-method-floating__method-title">
                    {{ paymentMethod$.value.title }} <span class="no-mobile"><sc-icon [icon]="paymentMethod$.value.icon" size="1"></sc-icon></span>
                </div>
            </div>
        </div>
        <sc-button
            type="link"
            class="edit-tarifas"
            id="floating-tarifas-formas-de-pago"
            [disabled]="disabled"
            (onClick)="linkClicked.emit()">
            Tarifas y formas de pago
        </sc-button>
        <sc-icon
            class="edit-tarifas"
            [class.sc-color-primary-brand]="!disabled"
            icon="edit"
            (click)="!disabled && linkClicked.emit()"></sc-icon>
    </div>
    <div *ngIf="!loading" class="sc-payment-method-floating__buttons">
        <sc-button
            id="continue-with-submission"
            type="primary" 
            [disabled]="disabled"
            (onClick)="primaryButtonClicked.emit()"
            >Continuar<span class="no-mobile"> con la emisión</span></sc-button>
        <sc-button
            id="payment-method-guardar-salir"
            type="secondary"
            [disabled]="disabled"
            (onClick)="secondaryButtonClicked.emit()"
            >Guardar y salir</sc-button>
    </div>
    <sc-info-box icon="info-2-rounded" class="info" *ngIf="infoMessage">{{infoMessage}}</sc-info-box>
</div>